import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActividadCalendario, Const, Usuario } from '@app/shared';
import { EndpointService } from '@app/core';

export interface systemUserTask {
  id: number;
  nombre: string;
  actividad: string;
  fecha_activacion: string;
  id_tramite: number;
  nombre_tramite: string;
  tramite_expediente: number;
  tramite_radicado_expediente?: any;
  tramite_radicado_solicitud: string;
  categoria: number;
  proceso: number;
  microproceso?: any;
  secundaria?: any;
  select?: boolean;
}

@Injectable()
export class CalendarService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta la información necesaria para generar el calendario de actividades.
   *
   * @param {number} idUsuario
   * @returns {Observable<ActividadCalendario[]>}
   * @memberof CalendarService
   */
  getDataCalendar(idUsuario: number): Promise<ActividadCalendario[]> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().get<ActividadCalendario[]>(this.api.get('activityCalendar', [idUsuario])).subscribe(
        data => {
          resolve(data);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(`No se pudó consultar la información del calendario`, 'Operación fallida');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Rechaza la tarea
   *
   * @param {number} idTarea
   * @param {string} motivo
   * @returns {Observable<boolean>}
   * @memberof CalendarService
   */
  rejectTask(idTarea: number, motivo: string): Observable<boolean> {
    const formData = {
      tarea_id: idTarea,
      descripcion: motivo
    };
    return new Observable(obs => {
      this.http.skipErrorHandler().post(this.api.get('rejectTask'), {
        tarea_id: idTarea,
        descripcion: motivo
      }).subscribe(
        data => {
          obs.next(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(`La tarea no se pudo rechazar`, 'Operación fallida');
          }
          obs.error(err);
        }
      );
    });
  }


  /**
   * Consulta los usuarios del sistema.
   *
   * @param 
   * @returns {Observable<>}
   * @memberof CalendarService
   */
  getSystemUsers(): Promise<any> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.systemUsers;
    return new Promise((resolve, reject) => {
      this.http.get(this.api.addParams(path, 'simple', [])).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta las actividades de calendario.
   *
   * @param 
   * @returns {Observable<>}
   * @memberof CalendarService
   */
  getActivitiesCalendar(user: Usuario): Promise<systemUserTask[]> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.calendar;
    return new Promise((resolve, reject) => {
      this.http.get<systemUserTask[]>(this.api.addParams(path, 'simple', [user.id])).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * actualiza la actividad
   *
   * @param {Actividad} activity
   * @return {*}  {Promise<Actividad>}
   * @memberof CalendarService
   */
  taskUpdate(task: any[], users?: any[], replace?: boolean): Promise<any> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.updateSystemUsers;
    const reemplazar = replace;
    let message = '';
    if(!reemplazar){
      message = 'Asignación realizada con éxito';
    }else{
      message = 'Reasignación realizada con éxito';
    }
    let dataForm = {
      tareas: task,
      responsables: users,
      reemplazar: reemplazar
    }
    return new Promise((resolve, reject) => {
      this.http.post<any>(this.api.addParams(path, 'simple', []), dataForm).subscribe(
        data => {
          this.toastr.success(message, 'Operación exitosa')
          resolve(data);
        },
        err => {
          if(err.status !== 400){
            this.toastr.error('Ha ocurrido un error al realizar la transacción', 'Error en la transacción')
          }else{
            this.toastr.warning('Ha ocurrido un error al realizar la transacción', 'Error en la transacción')
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/calendar/shared/calendar.service.ts